var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news_detail wh100"},[_c('navBar',{attrs:{"title":_vm.title,"leftArrowFlag":true}}),_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.detail.title))]),_c('p',{staticClass:"time"},[_vm._v("发布于"+_vm._s(_vm._f("timeFormat1")(_vm.detail.gmtCreate)))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }